import React, { useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import "./blogs.css";
import blog1 from "../assets/blog2-1.png";
import blog2 from "../assets/blog2-2.png";
function Blog2() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleMode = () => {
    setDarkMode(!darkMode);
  };
  return (
    <div className={`base-blog1 ${darkMode ? "dark" : "light"}`}>
      <div id="head-toggle-blog">
        <h1
          style={{
            textTransform: "initial",
            textDecoration: "underline",
            marginTop: "20px",
          }}
        >
          Dealing with Postpartum
        </h1>
        <div className="toggle-contents">
          <div
            className={`toggle-container ${darkMode ? "dark" : "light"}`}
            onClick={toggleMode}
          >
            <div className={`toggle-circle ${darkMode ? "dark" : "light"}`}>
              {darkMode ? (
                <FaMoon className="icon-blog moon" />
              ) : (
                <FaSun className="icon-blog sun" />
              )}
            </div>
          </div>
        </div>
      </div>
      <div id="blog-page-static">
        <p style={{ lineHeight: "1.5" }}>
          Finally, the arrival of your sweet little one—the moment you’ve been
          waiting for! But then, bam, you’re hit with the postpartum reality
          check. The adorable baby snuggles are just the beginning; the journey
          doesn’t stop there. Your body, your mind, and, yes, your emotions are
          all adjusting to this beautiful new chapter.
        </p>
        <div style={{ padding: "10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}>
            So, how do you navigate this rollercoaster after the baby arrives?
            Grab your favourite comfort snack, maybe a cup of coffee, and let’s
            dive into the real talk of postpartum life!
          </p>
        </div>
        <div style={{ padding: "0px 0px 10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}>
            You’ve just given birth, and suddenly your body is—well, it’s still
            figuring itself out. From post-delivery discomforts to changes you
            weren’t prepared for, your body needs time to recover and adjust.
            But hey, you just brought a tiny human into the world—cut yourself
            some slack. You’re a superhero, and superheroes need recovery time!
          </p>
        </div>
      </div>

      <div className="flexie-blog">
        <div style={{ position: "relative" }}>
          <img src={blog1} alt="blog1-1st image" className="blog1-1" />
        </div>
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>The Emotional Rollercoaster</h3>
          <p>
            One minute you’re crying over how cute your baby looks on their one
            side, and the next, you’re sobbing because you dropped your
            favourite snack on the floor. Postpartum hormones are no joke! You
            might feel like you’re on an emotional rollercoaster, but trust that
            you’re not alone. It’s all part of the ride, and soon enough, you’ll
            be back to feeling like your fabulous self—just with a little extra
            love (and a few extra bags under your eyes).
          </p>
          <h3>Sleep Deprivation</h3>
          <p>
            You thought you were tired during pregnancy?, you have no idea what
            sleep deprivation really feels like until you’re a new parent. Night
            after night of interrupted sleep will make you dream of the days
            when you could sleep for more than 3 hours at a stretch. But here’s
            the secret: even though you’ll be running on fumes, the moment your
            baby smiles or lets out a little giggle, it’ll all be worth it.
          </p>
        </div>
      </div>
      <div className="flxie-blog1">
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>The Physical Recovery</h3>
          <p>
            Postpartum recovery isn’t just about the emotional side—there’s the
            physical recovery to consider, too! From pelvic floor exercises to
            taking care of your “down there” area, your body needs time to heal.
            Don’t be afraid to ask for help and take things at your own pace.
          </p>
          <h3>The Joys of Motherhood</h3>
          <p>
            Through all the exhaustion, the baby spit-up, and the endless
            feedings, there’s so much joy in this new chapter. The tiny legs,
            the cuddles, and the way your baby looks at you like you’re their
            whole world—it’s all magic. Despite the chaos, your heart will never
            be fuller, and your love for your baby will grow in ways you never
            imagined.
          </p>
          <h3> Remember</h3>
          <p>
            The postpartum period is a journey that’s not always easy, but it’s
            filled with small wins and beautiful moments. You’re allowed to have
            hard days, but you’re also allowed to ask for help, take breaks,
            and, most importantly, celebrate the fact that you just did the
            hardest thing in the world.
          </p>
        </div>
        <div>
          <img src={blog2} alt="Blog1-2nd image" className="blog1-2" />
        </div>
      </div>
    </div>
  );
}

export default Blog2;
